<template>
	<div>

		<ul style="float: left;text-align: left;width: 50%;">
			<el-card>
				<div slot="header" style="text-align: left;">
					<span><b>已选项目</b>{{SelTotal}}</span>
				</div>
				<el-card>
					<el-row>
						<el-button plain type="warning" @click="btnSaveModule">将分组项目保存成模板</el-button>
						<el-input style="width: 270px;" placeholder="请输入模板名称" v-model="txtMName"></el-input>

					</el-row>
					<el-row>
						<el-button plain type="warning" @click="btnDiscount">按折扣调价</el-button>
						<el-input style="width: 70px;" type="number" placeholder="折扣" v-model="avgdiscount"></el-input>
						<el-button plain type="warning" @click="btnAvg">按总价平摊</el-button>
						<el-input style="width: 160px;" type="number" placeholder="请输入平摊金额" v-model="avgcash">
						</el-input>

					</el-row>
					<li>
						<el-button round type="primary" @click="btnOK">保存分组项目</el-button>
					</li>
				</el-card>

				<!-- <li><h3>当前分组：{{groupEnt.GroupName}}[分组金额：{{groupEnt.GroupPrice}}][适用性别：{{groupEnt.Sex}}]</h3></li> -->
				<el-card>
					<el-table max-height="520px" border @row-dblclick="SelItemdbclick" tooltip-effect="dark" :data="SelSaleModuleList">
						<el-table-column prop="SaleModuleName" label="项目名称" width="200px"></el-table-column>
						<el-table-column prop="OrgPrice" label="原价" width="100px"></el-table-column>
						<el-table-column prop="Discount" label="折扣" width="100px"></el-table-column>
						<el-table-column prop="CurPrice" label="售价" width="100px"></el-table-column>
					</el-table>
				</el-card>

			</el-card>

		</ul>
		<ul style="float: left;text-align: left;width: 50%;">
			<el-card>
				<div slot="header" style="text-align: left;">
					<span><b>系统项目</b></span>
				</div>
				<el-card>
					<el-row>
						选择模板：<el-select v-model="MID" style=" width: 200px;" @change="onModulChange" placeholder="请选择">
							<el-option v-for="item in MyModulsShow" :label="item.MName" :value="item.MID">
								{{ item.MName }}
							</el-option>
						</el-select>
					</el-row>
					<li>
						<el-input type="text" v-model="txtFind" placeholder="项目名称拼音首字母查找" @input="FindTextChange()">
						</el-input>
					</li>
				</el-card>
				<el-card>
					<el-table max-height="500px" border ref="multipleTable" @row-dblclick="SysItemdbclick" tooltip-effect="dark"
						:data="SaleModuleListShow.slice((currentPage-1)*pagesize,currentPage*pagesize)">
						<el-table-column prop="SaleModuleName" label="项目名称" width="200px"></el-table-column>
						<el-table-column prop="OrgPrice" label="原价" width="100px"></el-table-column>
						<el-table-column prop="MiniDiscount" label="最低折扣" width="120px"></el-table-column>
					</el-table>
					<el-footer style="margin-top:20px;">
						<template>
							<div class="block">
								<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
									:current-page="currentPage" :page-sizes="[5, 10, 20, 40]" :page-size="pagesize"
									layout="total, sizes, prev, next, jumper" :total="SaleModuleListShow.length">
								</el-pagination>
							</div>
						</template>
					</el-footer>
				</el-card>
			</el-card>
		</ul>

	</div>


</template>

<script>
	import Vue from 'vue'
	import enums from '../../commontools/enums.js'
	import groupitem from '../../apifunction/GroupItem.js'
	import commfun from '../../commontools/CommonFun.js'
	import salermodul from '../../apifunction/SalerModul.js'
	import py from '../../commontools/chineseToPinYin.js'
	import '../../assets/css/mystyle.css'
	export default {
		created() {
			this.initData();

		},
		watch: {
			// "$route": "initData"
			'groupEnt.GroupID': function(val, oldval) {
				{
					this.avgcash = this.groupEnt.GroupPrice;
					//this.InitSalerModuls();
					this.InitSelSaleModules();
				}
			}
		},
		data() {
			return {
				currentPage: 1,
				pagesize: 10,
				userent: this.$myglobal.getUserInfo(),
				groupEnt: this.inordergroup,
				MID: '',
				avgcash: 0,
				avgdiscount: 1,
				SelTotal: '',
				txtFind: '',
				txtFindm: '',
				MyModulsAll: [],
				MyModulsShow: [],
				txtMName: '',
				SelSaleModuleList: [],
				SaleModuleListAll: [],
				SaleModuleListShow: [],
				SaleItemAll: []
			}
		},
		props: ['inordergroup'],
		mounted() {

		},
		methods: {
			initData() {
				// alert(1)
				this.avgcash = this.groupEnt.GroupPrice;
				this.InitAllSaleModule();
				this.InitSalerModuls();
				this.InitSaleItemAll();
				this.InitSelSaleModules();
			},
			handleSizeChange: function(size) {
				this.pagesize = size;
			},
			handleCurrentChange: function(currentPage) {
				this.currentPage = currentPage;
			},
			btnSaveModule: function() {
				if (this.SelSaleModuleList.length < 1) {
					return;
				}
				if (this.txtMName == '') {
					this.$message.info('请填写模板名称！');
					return;
				}
				salermodul.SaveSalerModul(this.txtMName, this.userent.id, this.groupEnt.OrderID, this.groupEnt.GroupID)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.$message.info('保存成功！');

						} else
							this.$message.info(ent.Msg)
					})
			},
			btnAvg: function() {
				// alert(JSON.stringify(this.SelSaleModuleList))
				// alert(JSON.stringify(this.SaleItemAll))
				groupitem.ChangeItemPrice(this.SelSaleModuleList, this.avgcash, '', this.SaleModuleListAll)
				this.ShowSelTotal();
			},
			btnDiscount: function() {
				groupitem.ChangeItemPrice(this.SelSaleModuleList, '', this.avgdiscount, this.SaleModuleListAll)
				this.ShowSelTotal();
			},
			FindTextChange: function() {
				if (this.txtFind == '') {
					this.SaleModuleListShow = JSON.parse(JSON.stringify(this.SaleModuleListAll));
					return;
				}
				//alert(py.chinesesToPY(this.SaleModuleListAll[0].SaleModuleName))
				var templist = this.SaleModuleListAll.filter(item => {
					if (item.py.toLowerCase().indexOf(this.txtFind.toLowerCase()) > -1) {
						//if (item.SaleModuleName.indexOf(this.txtFind) > -1) {
						return item
					}
				});
				this.SaleModuleListShow = JSON.parse(JSON.stringify(templist));
			},
			// FindmTextChange: function() {
			// 	if (this.txtFindm == '') {
			// 		this.MyModulsShow = JSON.parse(JSON.stringify(this.MyModulsAll));
			// 		return;

			// 	}

			// 	var templist = this.MyModulsAll.filter(item => {
			// 		// if (py.chineseToPY(item.OrderName).indexOf(py.chineseToPY(this.txtQOrderName)) > -1) 
			// 		if (item.MName.indexOf(this.txtFindm) > -1) {
			// 			return item
			// 		}
			// 	});
			// 	this.MyModulsShow = JSON.parse(JSON.stringify(templist));
			// },
			InitSalerModuls: function() {
				salermodul.GetSalerModules(this.userent.id)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							if (ent.Data == 'null')
								return;
							this.MyModulsAll = JSON.parse(ent.Data);
							this.MyModulsShow = JSON.parse(ent.Data);
						}
					})
			},
			InitSaleItemAll: function() {

				groupitem.GetSaleItemAll(this.userent.corpid)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							if (ent.Data == 'null')
								return;
							this.SaleItemAll = JSON.parse(ent.Data);

						}
					})
			},
			InitAllSaleModule: function() {
				groupitem.GetSaleModuleValid(this.userent.corpid)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {

							this.SaleModuleListAll = JSON.parse(ent.Data);
							for (let i = 0; i < this.SaleModuleListAll.length; i++) {
								this.SaleModuleListAll[i].py = py.chinesesToPY(this.SaleModuleListAll[i]
									.SaleModuleName)
							}
							this.SaleModuleListShow = JSON.parse(ent.Data);

						}
					})
			},
			InitSelSaleModules: function() {
				groupitem.GetGroupItemDataByGroup(this.groupEnt.OrderID, this.groupEnt.GroupID)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data));
						if (ent.Flag == 'success') {
							if (ent.Data == 'null')
								return;
							var list = JSON.parse(ent.Data);
							for (let i = 0; i < list.length; i++) {
								var item = this.GetSelSaleModule(list[i]);
								this.SelSaleModuleList.push(list[i])
							}
							this.ShowSelTotal();
						}
					})
			},
			ShowSelTotal: function() {
				if (this.SelSaleModuleList == null || this.SelSaleModuleList.length < 1)
					this.SelTotal = '【无项目】';
				else {
					let sum = 0;
					let salesum = 0;
					for (let i = 0; i < this.SelSaleModuleList.length; i++) {
						var li = this.SelSaleModuleList[i];
						sum += parseFloat(li.OrgPrice);
						salesum += parseFloat(li.CurPrice);
					}
					this.SelTotal = '【总计：原价' + parseFloat(sum).toFixed(1) + ';售价' + parseFloat(salesum).toFixed(1) +
						';折扣' + parseFloat(
							salesum / sum).toFixed(4) + '】';
				}
			},
			SysItemdbclick(item, event) {
				var ent = this.GetSelSaleModule(item);
				let obj = this.SelSaleModuleList.find(v => v.SaleModuleID === ent.SaleModuleID);
				if (obj) {
					this.$message.info('项目已存在！')
				} else {
					if (item.AdaptSex != '3' && this.groupEnt.Sex != '3' && item.AdaptSex != this.groupEnt.Sex) {
						this.$message.info('选项与‘分组适用性别’不符！');
						return;
					}
					var msg = groupitem.CheckRepeatItem(ent, this.SelSaleModuleList, this.SaleItemAll)
					if (msg == '') {
						//alert(JSON.stringify(ent))
						this.SelSaleModuleList.push(ent)
						this.ShowSelTotal();
					} else
						this.$message.info(msg);
				}
			},
			SelItemdbclick: function(item, event) {
				let index = this.SelSaleModuleList.findIndex(f => f.SaleModuleID == item.SaleModuleID);
				this.SelSaleModuleList.splice(index, 1)
				this.ShowSelTotal();
			},
			onModulChange: function() {
				this.$confirm('更换模板将清空目前已选项目，确定更换吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(res => {
					this.loadModuleItems(this.MID);
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			loadModuleItems(MID) {
				salermodul.GetSalerModulItemByMid(MID)
					.then(res => {
						// alert(JSON.stringify(mitem.MID))
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {

							this.SelSaleModuleList = [];
							var list = JSON.parse(ent.Data);
							//alert(JSON.stringify(list[0].SaleModuleID))
							for (var i = 0; i < list.length; i++) {
								var temp = this.SaleItemAll.find(v => v.salemoduleid == list[i].SaleModuleID);

								if (temp && temp.MiniDiscount > list[i].Discount) {
									list[i].Discount = temp.MiniDiscount;
									list[i].CurPrice = parseFloat(list[i].OrgPrice * temp.MiniDiscount).toFixed(2);
								}
								this.SelSaleModuleList.push(this.GetSelSaleModule(list[i]))
							}
							this.ShowSelTotal();
						}
					})
			},
			GetSelSaleModule: function(ent) {
				return {
					SaleModuleID: ent.SaleModuleID,
					SaleModuleName: ent.SaleModuleName,
					OrgPrice: ent.OrgPrice,
					Discount: ent.Discount,
					CurPrice: ent.CurPrice,
					MiniDiscount: 0

				}
			},
			btnOK: function() {
				if (this.groupEnt == null) {
					this.$message.info('请选择分组！');
					return;
				}
				if (this.SelSaleModuleList.length < 1) {
					this.$message.info('请选择分组检项！');
					return;
				}
				// alert(JSON.stringify(this.groupEnt))
				groupitem.SaveGroupItem(this.groupEnt.OrderID, this.groupEnt.GroupID, this.SelSaleModuleList)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.$message.info('保存成功！');

						} else
							this.$message.info(ent.Msg);
					})

			}
		}

	}
</script>
